import Marquee from "react-fast-marquee";

export const StrikeMarquee = ({ section }) => {
  if (!section) return null;

  const words = section.metadata?.words || [];
  if (words.length === 0) return null;

  return (
    <div data-testid="marquee" className="py-10 md:py-16 border-y border-white/10 bg-[#050505] overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((word, index) => (
          <span key={`${word}-${index}`} className="flex items-center">
            <span className="font-anton uppercase text-stroke text-6xl md:text-8xl lg:text-9xl px-8">
              {word}
            </span>
            <span className="text-[#E85A24] text-4xl md:text-6xl px-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
